import React from 'react';
import * as H1 from '../Helper/H1';
import Send from '../Helper/Send';
import { NavLink, useParams, useNavigate } from 'react-router-dom';
import { Message, Input, Form, Schema, Animation, Button } from 'rsuite';



function withParams(Component) {
  return props => <Component {...props} params={useParams()} navigation={useNavigate()} />;
}



export class Page extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      page_slug: this.props.params.id,
      page: null,
    };

  }


  // ---------------- componentDidMount--------------------------

  componentDidMount() {

    Send('page/pages/single/' + this.state.page_slug, "", true).then((res) => {


      if (!res.data.page) {
        this.props.navigation('/404');
      }

      this.setState({
        page: res.data.page,
      });


    }).catch((err) => { });

    H1.NavHide();
  }



  // ---------------- componentWillUnmount--------------------------

  componentWillUnmount() {

    H1.NavShow();
  }








  render() {

    this.state.diet && H1.page_name(this.state.diet.name);

    return !this.state.page ? null : (


      <div className="h-100 mt-4">




        <div className='c-row'>


          <div className="text-center mb-2 py-2 position-relative">

            <span className="icon-Back fs-3 position-absolute top-50 end-0 translate-middle-y" onClick={() => this.props.navigation(-1)}></span>
            <span className='fs-6'> {this.state.page.name} </span>


          </div>


        </div>



        <div className="c-row mt-4">



            {this.state.page.cover &&
              <img className='br-16' src={this.state.page.cover} width="100%" />
            }





          {this.state.page.dis &&

              <div className='align-self-center bg-white br-16 p-3 mt-3 ws-br'>
                {this.state.page.dis} 
              </div>

           
            }

        </div>




      </div>

    )

  }
}

export default withParams(Page);
